"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertAfterButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const sds_1 = require("@squiz/sds");
const InsertAfterButton = ({ disabled = false, onClick }) => {
    return ((0, jsx_runtime_1.jsx)(sds_1.Button, { disabled: disabled, format: sds_1.BUTTON_FORMAT_SOFT, icon: (0, jsx_runtime_1.jsx)(icons_material_1.LowPriority, {}), onClick: onClick, text: "Insert after", theme: sds_1.BUTTON_THEME_DEFAULT }, `insert-after-btn`));
};
exports.InsertAfterButton = InsertAfterButton;
